import logo from './logo.svg';
import './App.css';
// src/index.js or src/App.js

import './assets/css/vendors.min.css';
import './assets/css/icon.min.css';
import './assets/css/style.min.css';
import './assets/css/responsive.min.css';
import './assets/demos/it-business/it-business.css';
import './assets/demos/corporate/corporate.css';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './component/layout/MainLayout';
import Home from './pages/home';
import OurHistory from './pages/our-history';
import Services from './pages/Services';
import OurConcern from './pages/our-concern';
import Contact from './pages/contact';
import Career from './pages/career';

function App() {
  return (
    <Router>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-history" element={<OurHistory />} />
          <Route path="/services" element={<Services />} />
          <Route path="/our-concern" element={<OurConcern />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;
